<div class="pl-pane__container--horizontal">
  <app-nav-bar></app-nav-bar>

  <app-ngin-iframe [path]="route"></app-ngin-iframe>
</div>

